module.exports = __webpack_public_path__ + "media/images/icon/courses-black-0f89875d327da2a11284b7d336c94930.svg";